import React from 'react';

const ContentIcon = (props) => {
  const { size, inner: InnerIcon, outer: OuterIcon, style } = props;
  const outerSide = size || 48;
  const innerSide = outerSide * 0.4;
  const STYLE = {
    root: {
      position: 'relative',
      width: outerSide,
      height: outerSide,
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    outer: {
      width: '100%',
      height: '100%',
    },
    inner: {
      position: 'absolute',
      width: innerSide,
      height: innerSide,
      zIndex: 10,
      color: 'white',
      marginTop: innerSide * 0.1,
    },
  };
  return (
    <div style={{ ...STYLE.root, ...style }}>
      <OuterIcon style={STYLE.outer} />
      {InnerIcon && <InnerIcon style={STYLE.inner} />}
    </div>
  );
};

export default ContentIcon;
